import { render, staticRenderFns } from "./CAS.vue?vue&type=template&id=8607428a&scoped=true&"
import script from "./CAS.vue?vue&type=script&lang=js&"
export * from "./CAS.vue?vue&type=script&lang=js&"
import style0 from "./CAS.vue?vue&type=style&index=0&id=8607428a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8607428a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCarousel,VCarouselItem})
